import Services from './base-services'

const service = new Services('mdTest')

export default {
    initTest(id: any, withClone:Boolean = false, initialReader: boolean = false, questionTemplate: number = 1) {
        return service.get(`initTest?id=${id}&withClone=${withClone}&initialReader=${initialReader}&questionTemplate=${questionTemplate}`, {}, false, true)
    },
    finish(data: any) {
        return service.post('finish', data, true)
    },
    findTestById(userId: number | string, testId: number | string, withClone: boolean) {
        return service.get(`findTestById?userId=${userId}&testId=${testId}&withClone=${withClone}`)
    },

}
